export default {
    BackendUrl: 'https://talenyatftbe-beta.herokuapp.com',
    WebAppUrl: 'https://beta.webapp.talenyanetwork.com',
};
